import { StandaloneSearchBox } from '@react-google-maps/api'
import React, { useCallback, useEffect, useRef } from 'react'
import SvgCrosshair from '../icons/SvgCrosshair'
import { Input } from '../Input'
import { GeolocPosition, processGeolocPosition, useGeolocPosition } from './useGeolocPosition'
import { useStandaloneSearchBox } from './useStandaloneSearchBox'

type VendorLocationSearchBoxProps = 
{
	currentAddress: google.maps.LatLngLiteral | null,
	onChangeAddress: (address: google.maps.LatLngLiteral | null) => void
}

const searchBoxBounds = { south: 47.5, west: 12, north: 51, east: 23 }
export const VendorLocationSearchBox: React.FC<VendorLocationSearchBoxProps> = ({
	currentAddress,
	onChangeAddress, 
}) => {
	const inputRef = useRef<HTMLTextAreaElement & HTMLInputElement>(null)
	const setAddress = useCallback((value: string) => {
		if (inputRef.current) {
			inputRef.current.value = value
		}
	}, [])

	const onChangePosition = useCallback(
		(position: GeolocPosition) => {
			onChangeAddress(position.location || null)
			setAddress(position.address || 'Moje poloha') // todo translate fallback
		},
		[onChangeAddress, setAddress],
	)
	const { queryPosition } = useGeolocPosition({ onChangePosition })
	const searchBoxProps = useStandaloneSearchBox({ onChangePosition })
	const onChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
			if (!e.currentTarget.value) {
				onChangeAddress(null)
			}
		},
		[onChangeAddress],
	)

	useEffect(() => {
		if(inputRef.current && !inputRef.current.value && currentAddress)
		{
			processGeolocPosition(currentAddress.lat, currentAddress.lng, (position) => {
				setAddress(position.address || 'Moje poloha');
			});
		}
	}, []);

	return (
		<form
			onSubmit={(event) => {
				event.preventDefault()
			}}
			className="vendorLocationSearchBox"
		>
			<StandaloneSearchBox bounds={searchBoxBounds} {...searchBoxProps}>
				<Input
					ref={inputRef}
					name="query-small-bland"
					// todo translate
					label="Adresa:"
					onChange={onChange}
					submitStyle="bland"
					micro
				/>
			</StandaloneSearchBox>
			{queryPosition && (
				<button
					className="vendorLocationSearchBox-find"
					type="button"
					onClick={queryPosition}
					aria-label="zaměřit polohu"
				>
					<SvgCrosshair />
				</button>
			)}
		</form>
	)
}
